import {
  AmadeusIcon,
  AmazonConnectIcon,
  AthenaOneIcon,
  CendynIcon,
  DialpadIcon,
  EpicIcon,
  FiveNineIcon,
  GenesysIcon,
  GladlyIcon,
  GoogleCalendarIcon,
  GoogleDriveIcon,
  GoogleSheetsIcon,
  HubspotIcon,
  IntegrationsIcon,
  JiraIcon,
  MicrosoftIcon,
  MicrosoftOutlookIcon,
  MicrosoftTeamsIcon,
  ModmedIcon,
  NiceIcon,
  NotionIcon,
  OpentableIcon,
  OracleCernerIcon,
  RaintreeIcon,
  SalesforceIcon,
  ServiceNowIcon,
  SlackIcon,
  SmsIcon,
  TripleseatIcon,
  TwilioIconAlt,
  WhatsappIcon,
  ZendeskIconAlt,
  ZoomIcon,
} from '../components/atoms/Icons';

export const INTEGRATION_LOGO_MAP = {
  // Telephony
  five9: FiveNineIcon,
  nice: NiceIcon,
  twilio: TwilioIconAlt,
  'amazon-connect': AmazonConnectIcon,
  genesys: GenesysIcon,
  'zendesk-talk': ZendeskIconAlt,
  zoom: ZoomIcon,
  dialpad: DialpadIcon,
  // Project Management
  jira: JiraIcon,
  // Calendar
  googleCalendar: GoogleCalendarIcon,
  // Chat
  whatsapp: WhatsappIcon,
  sms: SmsIcon,
  'salesforce-chat': SalesforceIcon,
  // CRM
  'salesforce-crm': SalesforceIcon,
  'zendesk-crm': ZendeskIconAlt,
  'microsoft-dynamics-365': MicrosoftIcon,
  hubspot: HubspotIcon,
  // Hospitality - Restaurant
  opentable: OpentableIcon,
  cendyn: CendynIcon,
  hotsos: AmadeusIcon,
  // Healthcare
  modmed: ModmedIcon,
  epic: EpicIcon,
  athenaone: AthenaOneIcon,
  'cerner-oracle-health': OracleCernerIcon,
  raintree: RaintreeIcon,
  // Knowledge Base
  'zendesk-knowledge-management': ZendeskIconAlt,
  'salesforce-knowledge-management': SalesforceIcon,
  gladly: GladlyIcon,
  'azure-ai-search': MicrosoftIcon,
  servicenow: ServiceNowIcon,
  slack: SlackIcon,
  notion: NotionIcon,
  googleDrive: GoogleDriveIcon,
  googleSheets: GoogleSheetsIcon,
  microsoftTeams: MicrosoftTeamsIcon,
  microsoftOutlook: MicrosoftOutlookIcon,
  oneDrive: MicrosoftIcon,
  sharepoint: MicrosoftIcon,
  confluence: IntegrationsIcon,
  freshdesk: IntegrationsIcon,
  'custom.tripleseat': TripleseatIcon,
} as const;
